module.exports = __webpack_public_path__ + "img/index_icon_1.4d2ddb08.png";